<template>
  <expand-transition>
    <div
      class="w-full bg-white shadow-md rounded-lg mb-8"
      v-if="this.quickFormId && !this.forceHide"
    >
      <div class="w-full px-4 pt-8 text-center">
        <div class="w-full px-8">
          <div>
            <p class="font-bold text-viva-money-black text-lg">
              It looks like you might have been here before
            </p>
          </div>
        </div>
        <div class="w-full px-8">
          <div class="text-sm">
            <p>
              If your details haven't changed since the last time you requested a quote, use our Quick form to simply reuse your details for a new quote.
            </p>
          </div>
        </div>
      </div>

      <div class="w-full p-4">
        <div class="w-full flex justify-between flex-wrap">
          <div class="w-full mb-2">
            <a
              @click="quickFormAccept"
              :href="'/quickform/' + quickFormId"
              class="button bg-red text-white px-4 py-3 w-full text-sm inline-block h-auto text-center hover:text-white hover:no-underline"
              >Use Quick form</a
            >
          </div>
          <div class="w-full text-center text-sm">
            <a class="text-viva-money-black underline" href="#" @click.prevent="noThanks"
              >I haven’t used this Loan service before</a
            >
          </div>
        </div>
      </div>
    </div>
  </expand-transition>
</template>

<script>
import { debounce } from "debounce";
import {
  emailRegex,
  dateRegex,
  mobileNumberRegex,
} from "./../../assets/js/regex";
const axios = require("axios").default;
export default {
  data() {
    return {
      searching: false,
      forceHide: false,
    };
  },

  components: {
    "expand-transition": require("./../expand-transition.vue").default,
  },
  props: ["customer", "surname", "dob", "email", "mobile", "quickFormId"],
  watch: {
    surname() {
      this.quickFormSearchHandler();
    },
    email() {
      this.quickFormSearchHandler();
    },
    mobile() {
      this.quickFormSearchHandler();
    },
    dob() {
      this.quickFormSearchHandler();
    },
  },
  methods: {
    noThanks() {
      window.amplitude.quickFormCheck('quickform_declined');
      this.forceHide = true;
    },
    quickFormAccept() {
      window.amplitude.quickFormCheck('quickform_accepted');
    },
    quickFormSearchHandler: debounce(function () {
      if (
        emailRegex.test(this.email) &&
        dateRegex.test(this.dob) &&
        /.{2,}/.test(this.surname) &&
        mobileNumberRegex.test(this.mobile)
      ) {
        this.doQuickformSearch();
      }
    }, 250),
    doQuickformSearch: debounce(function () {
      if (this.searching || this.quickFormId) {
        return;
      }

      this.searching = true;

      let data = {
        surname: this.surname,
        email: this.email,
        mobile: this.mobile,
        dob: this.dob,
      };

      axios
        .post("/quickform", data)
        .then((response) => {
          if (
            response.status === 200 &&
            response.data.status === "ok" &&
            response.data.id
          ) {
            if (this.quickFormId) {
              return;
            }
            // Get the quickform id
            window.amplitude.quickFormCheck('quickform_box_displayed');
            this.$emit("update:quickFormId", response.data.id);
          }
        })
        .then(() => {
          this.searching = false;
        });
    }, 1000),
  },
};
</script>

<style lang="scss"></style>
